import {
  ACCIDENT_ABOUT_STEP,
  ACCIDENT_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/Accident/accidentSteps";

import { AccidentProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductIntro/accidentProductIntroFormValues";
import { AccidentProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductPrice/accidentProductPriceFormValues";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getYYYYMMDDFromAge } from "Utils/dateUtils";
import { formBooleanToBoolean } from "Utils/formUtils";

export interface AccidentProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;

  isInsuredOwner: boolean;
  insuredOwnerAge?: number;
  deathCoverageAmount: number;
  disabilityCoverageAmount: number;
  dateOfBirth: string;
}

export const mapToCommerceAccident = (
  data: Record<string, any>,
): AccidentProductBackend => {
  const aboutData: AccidentProductIntroFormValues =
    data.formData[ACCIDENT_ABOUT_STEP.id];
  const priceData: AccidentProductPriceFormValues =
    data.formData[ACCIDENT_PRICE_STEP.id];
  const user = data.customerData.newCustomerResponse;
  const isInsuredOwner = formBooleanToBoolean(aboutData.isInsuredOwner);

  return {
    name: INSURANCE_NAME_VALUE.ACCIDENT,
    coverageGroup: data.coverage,

    isInsuredOwner: isInsuredOwner,
    insuredOwnerAge: isInsuredOwner ? undefined : aboutData.insuredOwnerAge,
    deathCoverageAmount: priceData.deathCoverageAmount,
    disabilityCoverageAmount: priceData.disabilityCoverageAmount,
    dateOfBirth: dateOfBirthFrom(
      isInsuredOwner,
      user.dateOfBirth,
      aboutData.insuredOwnerAge,
    ),
  };
};

const dateOfBirthFrom = (
  isInsuredOwner: boolean,
  userDateOfBirth: string,
  otherOwnerAge?: number,
): string => {
  if (!isInsuredOwner && otherOwnerAge) {
    return getYYYYMMDDFromAge(otherOwnerAge);
  }
  return userDateOfBirth;
};
